<template>
  <svg
    width="41"
    height="42"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="21" r="20.5" fill="#F1F8FF" />
    <path
      d="M26 12.5C26.2449 12.5 26.4813 12.59 26.6644 12.7527C26.8474 12.9155 26.9643 13.1397 26.993 13.383L27 13.5V29.5C26.9997 29.7549 26.9021 30 26.7272 30.1854C26.5522 30.3707 26.313 30.4822 26.0586 30.4972C25.8042 30.5121 25.5536 30.4293 25.3582 30.2657C25.1627 30.1021 25.0371 29.8701 25.007 29.617L25 29.5V24.5H24C23.7551 24.5 23.5187 24.41 23.3356 24.2473C23.1526 24.0845 23.0357 23.8602 23.007 23.617L23 23.5V17.5C23 15.29 24.5 12.5 26 12.5ZM20 12.5C20.2449 12.5 20.4813 12.59 20.6644 12.7527C20.8474 12.9155 20.9643 13.1397 20.993 13.383L21 13.5V18.5C20.9999 19.3869 20.7052 20.2486 20.1622 20.9498C19.6192 21.651 18.8586 22.1519 18 22.374V29.5C17.9997 29.7549 17.9021 30 17.7272 30.1854C17.5522 30.3707 17.313 30.4822 17.0586 30.4972C16.8042 30.5121 16.5536 30.4293 16.3582 30.2657C16.1627 30.1021 16.0371 29.8701 16.007 29.617L16 29.5V22.374C15.1755 22.1608 14.4404 21.6902 13.9018 21.0305C13.3631 20.3708 13.049 19.5565 13.005 18.706L13 18.5V13.5C13.0003 13.2451 13.0979 13 13.2728 12.8146C13.4478 12.6293 13.687 12.5178 13.9414 12.5028C14.1958 12.4879 14.4464 12.5707 14.6418 12.7343C14.8373 12.8979 14.9629 13.1299 14.993 13.383L15 13.5V18.5C15 18.8511 15.0924 19.1959 15.268 19.5C15.4435 19.804 15.696 20.0565 16 20.232V13.5C16.0003 13.2451 16.0979 13 16.2728 12.8146C16.4478 12.6293 16.687 12.5178 16.9414 12.5028C17.1958 12.4879 17.4464 12.5707 17.6418 12.7343C17.8373 12.8979 17.9629 13.1299 17.993 13.383L18 13.5L18.001 20.232C18.2801 20.0707 18.516 19.8443 18.6887 19.5722C18.8614 19.3 18.9658 18.9902 18.993 18.669L19 18.5V13.5C19 13.2348 19.1054 12.9804 19.2929 12.7929C19.4804 12.6054 19.7348 12.5 20 12.5Z"
      fill="url(#paint0_linear_2001_4388)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2001_4388"
        x1="20"
        y1="12.5"
        x2="20"
        y2="30.4989"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
